import {
  FaInstagram,
  FaFacebook,
  FaDiscord,
  FaTelegram,
  FaTwitter,
} from "react-icons/fa";

export const headerLinks = [
  {
    text: "RESOURCES",
    link: "",
  },
  {
    text: "SOCIALS",
    link: "",
  },
  {
    text: "LINKS",
    link: "",
  },
];

export const socialLinks = [
  {
    icon: <FaInstagram />,
    link: "",
  },
  {
    icon: <FaFacebook />,
    link: "",
  },
  {
    icon: <FaDiscord />,
    link: "",
  },
  {
    icon: <FaTelegram />,
    link: "",
  },
  {
    icon: <FaTwitter />,
    link: "",
  },
];
